import { 
  Component, 
  OnInit, 
  ElementRef, 
  ViewChild, 
  AfterViewInit, 
  Input, 
  Output, 
  EventEmitter} from '@angular/core';
import { Router } from '@angular/router';
import JSONFormatter from 'json-formatter-js';
import { DialogService } from '../_services/dialog.service';
import { JsonEditorField } from '../_models/JsonEditorField';

@Component({
  selector: 'app-visual-json-editor',
  templateUrl: './json-visual-editor.component.html',
  styleUrls: ['./json-visual-editor.component.css'],
})

export class JsonVisualEditorComponent implements OnInit, AfterViewInit {
  @ViewChild('jsonFormat')
  jsonFormat: ElementRef;

  public formatter: JSONFormatter;

  public json: object = {};
  public jsonEditorFields = [];

  public restrictedKeyValuePairs;

  @Input()
  public showPreview: boolean = true;

  @Input()
  public showTopKeyValues: number = 0;
  @Input()
  public showAllKeyValues: boolean = false;

  @Input()
  public set setJson(value: object) {

    if (value) {
      this.json = value;
      this.ngOnInit();
    }
  };

  @Input()
  public set setRestrictedKeyValuePairs(value: object) {

    if (value) {

      this.restrictedKeyValuePairs = value;
      this.ngOnInit();
    }
  }

  @Input()
  public objectName: string;
  @Input()
  public disableObjectName: boolean = false;

  @Output()
  public objectNameChange = new EventEmitter<string>();

  public jsonPairs = [];
  public nestTracker = [];
  public listOfTypes = [
    'Array',
    'Object',
    'String',
    'Number',
    'Boolean',
    'Null'
  ];

  @Output()
  public outputJson = new EventEmitter<any>();

  constructor(
    public dialogService: DialogService,
    private router: Router,
  ) { }

  ngOnInit() {

    if (this.json && this.restrictedKeyValuePairs) {

      this.jsonEditorFields = this.objectToJsonEditorFieldsObject(this.json, false, this.restrictedKeyValuePairs);
      this.renderJson(this.keyTypeValueArrayToJson(this.jsonEditorFields, false));
    }
  }

  ngAfterViewInit() {
    this.formatter = new JSONFormatter(this.json);
    this.jsonFormat.nativeElement.appendChild(this.formatter.render());

    this.renderJson(this.keyTypeValueArrayToJson(this.jsonEditorFields, false));
  }

  reload () {

    if (this.jsonEditorFields) {

      this.renderJson(this.keyTypeValueArrayToJson(this.jsonEditorFields, false));
    }
  }

  savePairToArray(targetArray, key, value, type) {
    const pair = { key, value, type };
    targetArray.push(pair);
  }

  keyTypeValueArrayToJson(array, isArray) {

    let json = isArray ? [] : {};

    array.forEach(pair => {
      if (Array.isArray(pair.value) && pair.type === 'Object') {

        json[pair.key] = this.keyTypeValueArrayToJson(pair.value, false);

      } else if (Array.isArray(pair.value) && pair.type === 'Array') {

        json[pair.key] = this.keyTypeValueArrayToJson(pair.value, true);

      } else {

        json[pair.key] = pair.value;
      }
    });

    return json;
  }

  objectEmpty(): boolean {
    return this.jsonEditorFields.length === 0;
  }

  objectToKeyTypeValue(object) {
    const entries = Object.entries(object);
    const objKeys = [];
    for (let ind = 0; ind < entries.length; ind++) {
      if (typeof entries[ind][1] === 'object' && entries[ind][1] !== null) {
        objKeys.push({
          key: entries[ind][0],
          value: this.objectToKeyTypeValue(entries[ind][1]),
          type: typeof entries[ind][1] === 'object' ? this.listOfTypes[0] :
                typeof entries[ind][1] === 'string' ? this.listOfTypes[1] :
                typeof entries[ind][1] === 'number' ? this.listOfTypes[2] : 
                typeof entries[ind][1] === 'boolean' ? this.listOfTypes[3] : this.listOfTypes[4]
        });
      } else {
        objKeys.push({
          key: entries[ind][0],
          value: entries[ind][1],
          type: typeof entries[ind][1] === 'object' && entries[ind][1] !== null ? this.listOfTypes[0] :
                typeof entries[ind][1] === 'string' ? this.listOfTypes[1] :
                typeof entries[ind][1] === 'number' ? this.listOfTypes[2] : 
                typeof entries[ind][1] === 'boolean' ? this.listOfTypes[3] : this.listOfTypes[4]
        });
      }
    }
    return objKeys;
  }

  objectToJsonEditorFieldsObject (object, isArray, restrictedKeyValuePairs) {

    if (!restrictedKeyValuePairs) {

      restrictedKeyValuePairs = {};
    }

    const entries = Object.entries(object);
    const objects = [];

    for (let ind = 0; ind < entries.length; ind++) {

      if (typeof entries[ind][1] === 'object' && entries[ind][1] !== null) {

        objects.push(new JsonEditorField({
          key: entries[ind][0],
          value: this.objectToJsonEditorFieldsObject(entries[ind][1], Array.isArray(entries[ind][1]), restrictedKeyValuePairs[entries[ind][0]]),

          type: Array.isArray(entries[ind][1]) ? this.listOfTypes[0] :
                typeof entries[ind][1] === 'object' ? this.listOfTypes[1] :
                typeof entries[ind][1] === 'string' ? this.listOfTypes[2] :
                typeof entries[ind][1] === 'number' ? this.listOfTypes[3] : 
                typeof entries[ind][1] === 'boolean' ? this.listOfTypes[4] : this.listOfTypes[5]

        }, isArray, restrictedKeyValuePairs[entries[ind][0]] !== undefined));

      } else {

        objects.push(new JsonEditorField({
          key: entries[ind][0],
          value: entries[ind][1],

          type: Array.isArray(entries[ind][1]) ? this.listOfTypes[0] :
                typeof entries[ind][1] === 'object' && entries[ind][1] !== null ? this.listOfTypes[1] :
                typeof entries[ind][1] === 'string' ? this.listOfTypes[2] :
                typeof entries[ind][1] === 'number' ? this.listOfTypes[3] : 
                typeof entries[ind][1] === 'boolean' ? this.listOfTypes[4] : this.listOfTypes[5]

        }, isArray, restrictedKeyValuePairs[entries[ind][0]] !== undefined));
      }
    }

    return objects;
  }

  renderJson(objectToRender) {
    this.formatter = new JSONFormatter(objectToRender, Infinity);

    if (this.jsonFormat) {
      this.jsonFormat.nativeElement.replaceChild(this.formatter.render(), this.jsonFormat.nativeElement.childNodes[0]);
    }

    this.outputJson.emit(this.formatter?.json);
  }

  editExistingPairValue(event, index) {
    const newValue = event.target.value;
    this.changePairValueAtIndex(index, newValue);

    this.renderJson(this.keyTypeValueArrayToJson(this.jsonEditorFields, false));
  }

  addNewFieldTo(arr, isArrayItem) {

    arr.push({ key: isArrayItem ? arr.length : 'New Key', value: 'New Value', type: this.listOfTypes[2], isArrayItem });
    this.renderJson(this.keyTypeValueArrayToJson(this.jsonEditorFields, false));
  }

  changePairValueAtIndex(index, newValue) {
    this.jsonEditorFields[index].value = newValue;
  }

  changeValueOfPair(pair, key, newValue) {
    pair[key] = newValue;
  }

  deleteItem(arrayToChange, index) {
    arrayToChange = arrayToChange.splice(index, 1);
    const temp = this.jsonEditorFields;
    this.jsonEditorFields = [];
    setTimeout(() => {
      this.jsonEditorFields = temp;
      this.renderJson(this.keyTypeValueArrayToJson(this.jsonEditorFields, false));
    }, 0);
  }

  handlePairOutput(value, arrayToChange, index) {
    const val = JSON.parse(value);
    if (val.key === '') {
     // arrayToChange.splice(index, 1);
    } else
      if (arrayToChange[index].key !== val.key) {
        arrayToChange[index].key = val.key;
      } else if (arrayToChange[index].type !== val.type) {
        arrayToChange[index].type = val.type;
        arrayToChange[index].value = val.type === this.listOfTypes[0] || 
                                     val.type === this.listOfTypes[1] ? [] : 
          val.type === this.listOfTypes[2] ? 'New Value' : 
          val.type === this.listOfTypes[3] ? 0 : 
          val.type === this.listOfTypes[4] ? true : null;
      } else {
        if (arrayToChange[index].type === this.listOfTypes[3]) {
          val.value = Number(val.value);
        }
        arrayToChange[index].value = val.value;
      }
    this.renderJson(this.keyTypeValueArrayToJson(this.jsonEditorFields, false));
  }

  trackByFn(index, item) {
    return index;
  }

  public navigateUp() {
    this.router.navigate(['portal/audio-qr']);
  }

  removeWhitespace() {
    this.objectName = this.objectName.split(' ').join('_');
    this.objectNameChange.emit(this.objectName);
  }
}
